// extracted by mini-css-extract-plugin
export default {"tableInfo":"TableInfo_tableInfo__H3G1U","tooltip":"TableInfo_tooltip__w2cDs","filterDark":"TableInfo_filterDark__K+2aV","filterLight":"TableInfo_filterLight__PcNBo"};